/** What a pinned line says when it has no words of its own: the name of the file it carries. */
export function pinWords(line: { body: string; attachments: readonly { name: string }[] }): string {
  return line.body.trim() || line.attachments[0]?.name || "";
}
